import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import ConversationPanel from "./ConversationPanel";
import { V } from "@/lib/vocab";

export default function ConversationView({ convId, role, open, onClose, onChanged }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl p-0 overflow-hidden gap-0 h-[75vh]">
        <DialogTitle className="sr-only">Conversation</DialogTitle>
        <DialogDescription className="sr-only">Full message thread with the {V.lc("person")}, including which rules the AI cited.</DialogDescription>
        <ConversationPanel convId={convId} role={role} onChanged={onChanged} />
      </DialogContent>
    </Dialog>
  );
}
